<div class="not-found">
  <h1>Seite nicht gefunden</h1>
  <p>Die von dir aufgerufene Seite konnte nicht gefunden werden.</p>
</div>
